import React from "react";
import { useParams } from "react-router-dom";
import PageWrapper from "../components/UI/PageWrapper";
import CustomerProfile from "../components/Support/CustomerProfile";

const CustomerProfilePage = () => {
  const { customerId } = useParams<{ customerId: string }>();
  
  return (
    <PageWrapper>
      <CustomerProfile customerId={customerId || ""} />
    </PageWrapper>
  );
};

export default CustomerProfilePage;

